import React, { useEffect, useState, useLayoutEffect, lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

// constants
import Loader from '../components/Common/loader';
import LocalStrings from '../languages';

// actions
import { checkEvent, deviceSize, showSidebar } from '../actions';
import { showBackScreen } from './mycourses/actions';

// components
import AdminLayout from '../layouts/Admin';
import { SITE_URL } from './Common/constant';
// const LazyAdminLayout = lazy(() => import('../layouts/Admin'));

const MainApp = props => {
  const { session } = props;
  const [isEventLoad, setEventLoad] = useState('');
  const location = useLocation();

  useEffect(() => {
    let hostname = window.location.hostname;
    let seocode = hostname.split(`.${SITE_URL}`)[0];

    props.checkEvent(session, seocode, res => {
      if (res.success) {
        setEventLoad('loadedcorrect');

        // ----- setting local language to dutch for this group_number
        let local_eventDetails = res.resource[0];
        if (local_eventDetails?.group_number == '1068')
          LocalStrings.setLanguage('nl');
        else {
          // --- Language extracting, checking in DB, setting locally
          // With this the filtered language file from DB will be set locally. If any key is not found, then it by default reverts back to default language(en)
          let param_lang = _.split(
            navigator.language || navigator.userLanguage,
            '-'
          ).shift();

          if (location.search != '' && location.pathname === '/myprofile') {
            const queryParams = new URLSearchParams(location.search);
            param_lang = queryParams.get('language');
          }

          // - filterring if param_language is present for the event in DB
          let filterLanArr = _.filter(
            local_eventDetails.eventlanguages_by_eventid,
            lang => lang.isenabled && lang.languagekey == param_lang
          );

          if (filterLanArr.length) {
            let local_lang = JSON.parse(filterLanArr[0].languagejson);

            LocalStrings.setContent({
              [filterLanArr[0].languagekey]: local_lang
            });
            LocalStrings.setLanguage(filterLanArr[0].languagekey);
          }
        }
      } else {
        setEventLoad('loadedwrong');
      }
    });
  }, []);

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const updateSize = () => {
    let device_size_obj = {
      width: window.innerWidth,
      height: window.innerHeight,
      isMobile: false
    };
    if (window.innerWidth < 576) device_size_obj.isMobile = true;
    else if (screen.width < 576) {
      device_size_obj = {
        width: screen.width,
        height: screen.height,
        isMobile: true
      };
    } else props.showBackScreen(false);

    props.deviceSize(device_size_obj);

    if (window.innerWidth > 991 || screen.width > 991) {
      props.showSidebar(false);
    }
  };

  return (
    <div className="container">
      <Switch>
        {isEventLoad != '' ? (
          <Route
            path="/"
            // render={props => <LazyAdminLayout {...props} />
            render={props => (
              <AdminLayout
                {...props}
                incorrectEvent={
                  isEventLoad == 'loadedcorrect' &&
                  session &&
                  session.eventid &&
                  session.eventid != ''
                    ? false
                    : true
                }
              />
            )}
          />
        ) : (
          <>
            <Loader />
          </>
        )}
      </Switch>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    session: state.session
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      checkEvent,
      deviceSize,
      showBackScreen,
      showSidebar
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MainApp);
